import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { UIModalServiceModal } from '../../../../app/package/base/service/modals/modal-service';
import { I18n } from '../../../base/package/services/package/i18n/i18n.de';
import type { UIModal } from '../../ui-modal/ui-modal';

const CName = 'ui-gamification-maintenance-modal-new';

@customElement(CName)
export class UIGamificationMaintenanceModalNew extends UIModalServiceModal {
  private _title = '';
  private _subTitle = '';
  private _cta = '';

  // intentional noop — modal service requires close(), but this modal
  // is only dismissible via its own CTA button
  public close() {} // NOSONAR — intentional empty override required by modal service contract

  connectedCallback(): void {
    super.connectedCallback();
    this._title = window.$app.$t.get(I18n.maintenance.gamificationTitle2026);
    this._subTitle = window.$app.$t.get(I18n.maintenance.gamificationSubtitle2026);
    this._cta = window.$app.$t.get(I18n.maintenance.gamificationCTA2026);
  }

  render() {
    return html`
      <ui-modal
        class="modal--centered"
        .isDismissible=${true}
        .actionButtonLabel=${this._cta}
         .onAction=${(modalEl: UIModal) => {
           modalEl.close();
         }}
      >
        <div slot="icon">
          <img
            width="120"
            height="120"
            alt="Gamification Maintenance"
            src="https://content.noenv.eu/assets/572248eb-8d6b-4b08-b2d8-74066de48238.webp"
          >
        </div>
        <div slot="title">${this._title}</div>
        <div slot="main">${this._subTitle}</div>
      </ui-modal>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [CName]: UIGamificationMaintenanceModalNew;
  }
}
